import React, { useState, useEffect } from 'react';
import { newsAPI } from '../../../../services/news.service';
import NewsList from './NewsList';
import NewsForm from './NewsForm';

const NewsManager = ({ showMessage }) => {
  const [newsList, setNewsList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [view, setView] = useState('list'); // 'list' or 'form'
  const [editingItem, setEditingItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [newsResponse, catsResponse] = await Promise.all([
        newsAPI.getAll(),
        newsAPI.getCategories()
      ]);
      
      const newsData = newsResponse.data?.results || newsResponse.data || [];
      const catData = catsResponse.data?.results || catsResponse.data || [];
      
      setNewsList(Array.isArray(newsData) ? newsData : []);
      setCategories(Array.isArray(catData) ? catData : []);
    } catch (error) {
      console.error('Ошибка загрузки новостей:', error);
      if(showMessage) showMessage('Ошибка загрузки новостей', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const data = new FormData();
      // Преобразуем объект в FormData
      Object.keys(formData).forEach(key => {
        if (key === 'media_files') {
            if (formData[key] && Array.isArray(formData[key])) {
                formData[key].forEach(file => {
                    data.append('media_files_data', file);
                });
            }
        } else if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      if (editingItem) {
        await newsAPI.update(editingItem.slug, data);
        if(showMessage) showMessage('Новость обновлена!');
      } else {
        await newsAPI.create(data);
        if(showMessage) showMessage('Новость создана!');
      }
      
      setView('list');
      setEditingItem(null);
      loadData();
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      if(showMessage) showMessage('Ошибка сохранения новости', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (slug) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту новость?')) return;
    try {
      await newsAPI.delete(slug);
      if(showMessage) showMessage('Новость удалена');
      loadData();
    } catch (error) {
      console.error('Ошибка удаления:', error);
      if(showMessage) showMessage('Ошибка удалении новости', 'error');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setView('form');
  };

  return (
    <div className="admin-content">
      <div className="content-header">
        <h2>{view === 'list' ? 'Управление новостями' : (editingItem ? 'Редактировать новость' : 'Создать новость')}</h2>
        <button
          className={`action-button ${view === 'form' ? 'secondary' : 'primary'}`}
          onClick={() => {
            if (view === 'form') {
              setView('list');
              setEditingItem(null);
            } else {
              setView('form');
              setEditingItem(null);
            }
          }}
        >
          {view === 'list' ? '➕ Создать новость' : '📋 К списку'}
        </button>
      </div>

      {view === 'list' ? (
        <NewsList 
          news={newsList} 
          onEdit={handleEdit} 
          onDelete={handleDelete} 
        />
      ) : (
        <NewsForm 
          initialData={editingItem} 
          categories={categories} 
          onSubmit={handleSubmit} 
          onCancel={() => { setView('list'); setEditingItem(null); }}
          loading={loading}
        />
      )}
    </div>
  );
};

export default NewsManager;
